
export default {
  name: 'EmptyLayout',
  layout: 'empty',
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pageNotFound: 'Página não encontrada',
      otherError: 'Ops! Algo deu errado',
    }
  },
  head() {
    const title =
      this.error.statusCode === 404 ? this.pageNotFound : this.otherError
    return {
      title,
    }
  },
  mounted() {
    if (this.$posthog && typeof window !== 'undefined') {
      try {
        const errorObj = new Error('Global Error Page of Nuxt was accessed')
        
        if (this.error?.stack && typeof this.error.stack === 'string') {
          errorObj.stack = this.error.stack
        }
        
        this.$posthog.captureException(errorObj, {
          statusCode: this.error?.statusCode || 'unknown',
          message: this.error?.message || this.error?.toString() || 'unknown',
          url: window.location.href,
          path: window.location.pathname,
        })
      } catch (e) {}
    }
  },
}
